__turbopack_context__.v({
  "buttonContainer": "error-pages-module__QpJIoW__buttonContainer",
  "container": "error-pages-module__QpJIoW__container",
  "main": "error-pages-module__QpJIoW__main",
  "message": "error-pages-module__QpJIoW__message",
  "primaryButton": "error-pages-module__QpJIoW__primaryButton",
  "secondaryButton": "error-pages-module__QpJIoW__secondaryButton",
  "title": "error-pages-module__QpJIoW__title",
});
